import {Component, OnInit} from '@angular/core';
import {AuthService} from '../../services/auth.service';
import {Banner} from '../../constants/constant-text';
import {ActivatedRoute} from '@angular/router';
import {DataService} from '../../services/data.service';
import {Scope} from '../../constants/scopes';
import {environment} from '../../../environments/environment';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  autoEnabled = false;
  googleLoading = false;
  scopes = [Scope.EMAIL, Scope.PROFILE, Scope.OPENID].join(' ');
  clientId = environment.clientId;
  public banner = Banner;
  public paramsMissing = false;

  constructor(private authService: AuthService,
              private dataService: DataService,
              private route: ActivatedRoute) {
  }

  ngOnInit(): void {
    if (this.saveQueryParams()) {
      this.autoEnabled = true;
    } else {
      this.paramsMissing = true;
    }
  }

  saveQueryParams(): boolean {
    const params = this.route.snapshot.queryParams;
    this.dataService.domain = params.domain;
    this.dataService.documentId = params.id;
    this.dataService.qaId = params.qaId;
    this.dataService.userId = params.userId;
    this.dataService.libraryId = params.libraryId;
    this.dataService.documentClassIdLog = params.documentClassIdLog;
    this.dataService.quizSheetName = params.quizSheetName;
    this.dataService.passMessage = params.passMessage;
    this.dataService.failMessage = params.failMessage;
    return !!this.dataService.domain
      && !!this.dataService.documentId
      && !!this.dataService.qaId
      && !!this.dataService.libraryId
      && !!this.dataService.documentClassIdLog
      && !!this.dataService.quizSheetName;
  }

  googleLoginSuccess(event: any): void {
    try {
      this.authService.signInWithGoogle(event.detail);
    } catch (e: any) {
      this.googleLoading = false;
      this.authService.authErrorMessage$.next(e.error);
    }
  }

  loginError(): void {
    this.googleLoading = false;
    this.authService.authErrorMessage$.next('Error: An error occurred during authentication');
  }

  googleAuth(): void {
    setTimeout(() => {
      this.googleLoading = true;
    });
  }

}
